import { useState, type KeyboardEvent } from 'react';
import styles from './MessageInput.module.css';

interface Props {
  onSend(text: string): void;
  disabled?: boolean;
}

export function MessageInput({ onSend, disabled }: Props) {
  const [draft, setDraft] = useState('');
  function send() {
    const t = draft.trim();
    if (!t) return;
    onSend(t);
    setDraft('');
  }
  function onKey(e: KeyboardEvent<HTMLInputElement>) {
    if (e.key === 'Enter') send();
  }
  return (
    <div className={styles.wrap}>
      <input
        className={styles.input}
        placeholder="Spørg din guide…"
        value={draft}
        onChange={(e) => setDraft(e.target.value)}
        onKeyDown={onKey}
        disabled={disabled}
      />
      <button className={styles.send} onClick={send} disabled={disabled || draft.trim() === ''}>
        Send
      </button>
    </div>
  );
}
